import { render } from "./BaseTextExpander.vue?vue&type=template&id=2ca8f7e3&scoped=true"
import script from "./BaseTextExpander.vue?vue&type=script&lang=js"
export * from "./BaseTextExpander.vue?vue&type=script&lang=js"

import "./BaseTextExpander.vue?vue&type=style&index=0&id=2ca8f7e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca8f7e3"]])

export default __exports__